import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { format } from 'date-fns';

const initialState = {
    loading: false,
    log: [],
    res: null
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
		case actionTypes.CDN_LOG_GET_START:
            return updateObject(state, { loading: true });
        case actionTypes.CDN_LOG_GET_SUCCESS:
            // from Günther
            /*action.res.content.split('#').forEach(entry=>{ 
                console.info(new Date(e[0] * 1000).toLocaleString("de-DE") ,e[1]); 
            });*/
            
            const data = (action.res.content && action.res.content.split('#')) || [];
            const log = data.map(entry => {
                return entry.split(';');
            });

            return updateObject(state, { loading: false, res: action.res, log: log.reverse() });
		case actionTypes.CDN_LOG_GET_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.CDN_LOG_RESET:
            return updateObject(state, { loading: false, res: null, log: [] });
        default: 
            return state;
    }
}

export default reducer;
